export const getIconSize = (type: string) => {
  if (type === 'small') {
    return 72
  }
  return 180
}
